import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import '@/assets/css/main.css'

Vue.config.productionTip = false

// Auth0
import { domain, clientId } from './auth/auth0-config'
import { Auth0Plugin } from './auth/auth0-plugin'

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

Vue.prototype.$store = store

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
